<template>
  <div class="all-search" v-show="serchStatus">
    <div class="search-mask ">
      <div class="search-mask-contant">
        <div class="search-mask-header "> 
          <div class="logo"> <img src="@/assets/logo.jpg" alt="logo"></div>
          <div class="close"> <i class="el-icon-close" @click="closedSearch"></i></div>
        </div>
        <div class="all-search-input">
          <input type="text" :class="inpt_search?'inp_s input1_focus':'inp_s'" ref="search_content" placeholder=" 请输入关键词" v-model="searchContent" 
          @input="serach_tips" 
          @blur="input_blur" 
          @focus="input_focus()"
          @keyup.enter="keyupSubmit"
          >
          <div class="search-tip" v-show="tips" >
          <div class="item-list" v-for="(item,index) in options2" 
          @mousedown="redirect_tips(item._source.title)"
          style="line-height:30px;cursor: pointer;" :key="index"
          >
              <span v-if="options2.length > 0 ">{{item._source.title}}【{{item._source.author}}】</span> <span v-if="index == 1" class="tips_hot">热</span>
          </div>
       </div>
        </div>
        
        <!-- <div class="hot-search">
          <div class="hot-tag"># 热门搜索 #</div>
          <ul class="hot-word">
            <li  v-for="(val,index) in searchHotwords" :key="index"><span  @click="click_redirect(val)" >{{val}}</span></li>
          </ul>
        </div> -->
      </div>

      <div class="hot-tuijian">
          <div class="hot-acticle">
            <h2>热门推荐</h2>
            
            <!-- 热门推荐 START-->
            <div class="hot-acticlelist" >
              <a target="_blank" :href="'http://www.iceo.com.cn/article/' + hotAticle[4]._uniquecode">
                <div class="new-img">
                <el-image v-if="hotAticle[4].thumb_image_url" :src="'http://www.iceo.com.cn/' + hotAticle[4].thumb_image_url" class="image" />
                </div>
                <div  class="shake">
                  <h3 >
                    {{hotAticle[4].title}}
                  </h3>
                  <p> {{hotAticle[4].summary}}</p>
                </div>
              </a>
             
            </div>
            <!-- 热门推荐 END -->



             <!-- <div class="hot-acticlelist" >
              <el-carousel :interval="4000" type="card" height="200px">
                <el-carousel-item v-for="item in 6" :key="item">
                  <h3 class="medium">{{ item }}</h3>
                  <img src="http://irm2at.iceo.com.cn/images/2023/12/7/a8c93d77-296b-492f-ac11-6146ed8475a9.jpg" alt="">
                </el-carousel-item>
              </el-carousel>
            </div> -->

          </div>
          <div class="hot-bang">
            <h2>最新热搜榜</h2>
            <ul>
              <span v-for=" (v,i) in hotAticle" :key="i" >
              <li v-if="i == 0"><span class="hot-number hot1">1</span><a target="_blank" :href="'http://www.iceo.com.cn/article/' + v._uniquecode">{{v.title}}</a></li>
              <li v-if="i == 1" ><span class="hot-number hot2">2</span><a target="_blank" :href="'http://www.iceo.com.cn/article/'+ v._uniquecode">{{v.title}}</a></li>
              <li v-if="i == 2" ><span class="hot-number hot3">3</span><a target="_blank" :href="'http://www.iceo.com.cn/article/'+ v._uniquecode">{{v.title}}</a></li>
              <li v-if="i == 3"><span class="hot-number ">4</span><a target="_blank" :href="'http://www.iceo.com.cn/article/'+ v._uniquecode">{{v.title}}</a></li>
            
              </span>
             </ul>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
   
    name: 'Search',
    data() {
      return {
        tips:false,
        inpt_search:false,
        isshow:false,
        searchContent:"",
        optionsData:[],
        options2:[],
        serchStatus:false,
        searchHotwords:['腾讯','房企','大模型','独角兽'],
        hotAticle:[]
      }
    },
    computed:{},
    created(){
      this.getHotArticle()
    },
    watch: {
      // searchContent(){
      //       var ipt_content=this.searchContent
      //       if(ipt_content){
      //              var item=this.options2.filter(ele=>{
      //              console.log(ele)
      //             //  console.log(ele.text)
      //             //  if(ele.text.match(ipt_content)){
      //             //    // console.log(ele.text.match(ipt_content))
      //             //    return ele;
      //             //  }
      //           })
      //          this.optionsData=item
      //       }
      //       console.log(this.optionsData)
      //},

      $route (to, from) {
        // this.$router.go(0)
        // window.location.reload()
      },
      
      
    },

    methods:{

      getHotArticle(){
        var config = {
            method: 'GET',
            url: '/api/v1/artical/hot',
            headers: { 
              'Content-Type': 'application/json'
            }
          };

          this.$axios(config).then(res=>{
            console.log(res.data)
            if(res.data.length > 0){
              this.hotAticle = res.data
              console.log('请求成功')
            }else{
              console.log('请求失败')
            }
          })


      },

      redirect_tips(strings){
        this.tips = false
        // this.search_content = strings
        this.$refs.search_content.value = strings
        this.keyupSubmit()
      },

      search_tips_opration(){
        // 聚焦输入框的时候，没有输入字段，先展示推荐内容
        // this.inputValue == '' ? this.showData = this.recommendedData : ''
        // this.tips = true
        var config = {
            method: 'GET',
            url: '/api/v1/search/tipskey',
            headers: { 
              'Content-Type': 'application/json'
            },
            params: {searchkey:this.searchContent}
          };

          this.$axios(config).then(res=>{
            if(res.data.hits.hits.length <=0){
              this.options2 = []
              // this.inpt_search = false
              this.tips = false
            }else{
              this.options2 = res.data.hits.hits
              this.tips = true
            }
          })
      },

      serach_tips(){
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.search_tips_opration()
        }, 150);
      },

      input_focus(){
        this.serach_tips()
      },

      input_blur(){
        this.tips = false
        this.inpt_search = false
      },

      inputFun2(){
            this.isshow=true
        },
        
        getOptionInfo(val,searchName){
            this.isshow=false
            this.searchContent=searchName
        },
         
      click_redirect(val){
        this.serchStatus = false
        // this.$router.push({path:'/search',query:{q:val}})
        // window.location.reload()

        let routeData=this.$router.resolve({path:'/search',query:{q:val}})
        window.open(routeData.href, '_blank');
      },
      closedSearch(){
        this.serchStatus = false
      },

      keyupSubmit(){
        this.serchStatus = false
        // this.$router.push({path:'/search',query: {q:this.$refs.search_content.value}})
        let routeData=this.$router.resolve({path:'/search',query: {q:this.$refs.search_content.value}})
        window.open(routeData.href, '_blank');

        }
    }
  }
</script>

<style>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>
<style scoped>

  .all-search {
    position: fixed;
    top: 0;
    left: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    z-index: 1000;
    overflow: hidden;
  }

  .search-mask {
    width: 100%;
    height: 100%;
    background: #f1f1f1;
    opacity: 0.98;
    overflow: auto;
    transition: opacity 1s ease 0s;
  }

  .opacity0 {
    opacity: 0;
  }

  .opacity1 {
    opacity: 1;
  }

  .search-mask-contant {
    width: 1200px;
    margin: auto;
  }

  .search-mask-header {
    padding-top: 66px;
  }

  .logo {
    width: 223px;
    display: block;
    /* float: left; */
    height: 52px;
    margin:0 auto;
  }

  .search-mask-header .close {
    width: 24px;
    height: 24px;
    float: right;
    position: relative;
    top: 20px;
    cursor: pointer;
  }

  .all-search-input {
   height: 76px; 
    width: 870px;
    margin: 55px auto 0px;
    position: relative;
  }
.search-tip{
  position: absolute;
  min-height: 60px;
  left: 0px;
  top:60px;
  z-index: 1000;
  background-color: #fff;
  width: 878px;
  border-radius: 8px;
  border: 2px solid #cc0033;
  border-top-width: 0px;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  font-size: 14px;
  text-align: left;
  line-height: 18px;
  text-indent: 10px;
  color: #2c3e50;
  padding: 10px 0px;
  box-sizing: border-box;
}
.all-search-input input {
  height: 66px;
  width: 878px;
  font-size: 23px;
  color: #4b4b4b;
  letter-spacing: 0;
  text-align: left;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #ccc;
  padding: 0px!important;
  text-indent: 10px;
  box-sizing: border-box;
}

  .hot-search {
    width: 880px;
    margin: 0 auto;
    margin-top: 50px;
  }

  .hot-tag {
    font-size: 20px;
    color: #4b4b4b;
    width: 120px;
    height: 30px;
    line-height: 30px;
    text-align: justify;
    font-weight: 500;
  }

  .hot-word {
    margin: 0px;
    padding: 0px;
  }

  .hot-word li {
    cursor: pointer;
    float: left;
    height: 35px;
    line-height: 35px;
    margin-right: 15px;
    margin-top: 20px;
    display: inline-block;
  }

  .hot-word li span {
    padding: 0 25px;
    background: #e1e1e1;
    border-radius: 1px;
    font-size: 20px;
    color: #4b4b4b;
    display: block;
    text-decoration: none;
    float: left;

  }

  .hot-word   li  a:hover {
    color: rgb(255, 98, 0);
  }

  .el-icon-close {
    font-size: 48px !important;
    color: #999;
  }

    .el-icon-close:hover {
      transition: opacity 1s ease 0s;
    }
    .search-xialaul{
      display: none;
    }

.el-card h3 {
  margin: 0;
  padding: 10px 10px 3px;
  font-size: 14px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  min-height: 48px;
}
.hot-tuijian{
width: 1080px;
margin: 0px auto;
padding: 60px 0px;
height: 160px;
clear: both;

}
.hot-tuijian h2{
  margin-bottom: 14px;
    color: #4b4b4b;
    font-size: 18px;
    line-height: 28px;
    font-weight: 500;
    text-align: left;
}
.hot-acticle{
  width: 640px;
  margin-right: 40px;
  float: left;
}
.hot-bang{
  width: 400px;
  float: left;
}
.hot-acticlelist{
width: 100%;
overflow: hidden;
margin: 25px auto 0px;
}
.new-img {
      height: 100px;
  overflow: hidden;
  position: relative;
  width: 150px;
  float: left;
}

.new-img:hover {
  cursor: pointer;
}
.image {
width:140px;
display: block;
position: relative;
top: -6px;
left: -6px;
}
.shake{
width:450px;
float: left;
font-size: 12px;
line-height: 18px;
text-align: left;
color:#303133;
}
.shake h3{
  padding: 0px;
  margin: 0px;
  font-size: 16px;
  line-height: 24px;
}
.shake h3:hover{
  cursor: pointer;
}

.shake p{
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  height: 54px;
  overflow: hidden;
}
.hot-bang h2{
  margin-bottom: 14px;
    color: #cc0033;
    font-size: 18px;
    line-height: 28px;
    font-weight: 500;
    text-align: left;
    font-weight: bold;
}
.hot-bang ul{
  margin: 0px;
  padding: 0px;
}
.hot-bang ul li{
padding: 0px;
margin: 0px;
font-size: 14px;
list-style: none;
  height: 30px;
  line-height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  color: #4b4b4b;

}
.hot-bang ul li a{
  color: #222;
}

.hot-bang ul li a:hover{
  color: #cc0033;
  text-decoration: underline;
}

.hot-number {
  font-size: 18px;
  width: 22px;
  height: 36px;
  line-height: 36px;
  background-size: 100% 100%;
  text-align: left;
  margin-right: 6px;
  position: relative;
  top: 1px;
}
.hot1{
  color: #fe2d46;
}
.hot2 {
  color: #f60;
}
.hot3 {
  color: #faa90e;
}


.inp_s{
  border-bottom-right-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
}

  .search_input_focus {
    text-indent: 20px;
    height: 64px;
    width: 679px;
    font-size: 36px;
    color: #4b4b4b;
    letter-spacing: 0;
    text-align: left;
    border-radius: 8px;
    background: #fff;
    outline: none;
    border-top: 2px solid #cc0033 !important;
    border-left: 2px solid #cc0033 !important;
    border-right: 2px solid #cc0033 !important;
    border-bottom: 2px solid #cc0033 !important;
    /* border: 2px solid #f1f1f1; */
    display: inline-block;
    padding: 0px; 
    vertical-align: middle;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    margin-right:10px;
  }


  .all-search-input input:focus{
    outline: none;
    border-top: 2px solid #cc0033 !important;
    border-left: 2px solid #cc0033 !important;
    border-right: 2px solid #cc0033 !important;
    border-bottom: 2px solid #cc0033 !important;
    /* border-bottom-right-radius: 8px; */
    /* border-bottom-left-radius: 8px; */
  }

  .input1_focus {
    /* border-bottom-width: 13px !important; */
    /* border-bottom-color: #4b4b4b !important; */
    /* border-bottom: 1px solid #4b4b4b !important; */
    outline: none;
    border-top: 2px solid #cc0033 !important;
    border-left: 2px solid #cc0033 !important;
    border-right: 2px solid #cc0033 !important;
    /* border-bottom: 2px solid #cc0033 !important; */
    border-bottom-right-radius: 0px !important;
    border-bottom-left-radius: 0px !important;



    /* border-bottom-left-radius: 0px; */
    /* border-bottom-right-radius: 0px; */
    /* border-bottom: 0;
    /* height: 64px;
    width: 679px;
    font-size: 36px;
    color: #4b4b4b;
    letter-spacing: 0;
    text-align: left;
    border-radius: 3px;
    background: #fff;
    /* border-color:#cc0033 !important; */
    /* border-top: 1px solid #f1f1f1;
    border-left: 1px solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1;
    border-right: none;
    display: inline-block;
    padding: 0px;
    vertical-align: middle; */
    /* border-top-right-radius: 0px; */
    /* border-bottom-right-radius: 0px; */
  }
  
  
  .item-list:hover{
  background: #f7ecee;
  color: #fa5d03;
  
 }

   .bgcolor {
    background: #ccc;
   }
   .tips_hot{
    display: inline-block;
    width:20px;
    height:20px;
    background: #3fba02;
    color: white;
    text-align: center;
    line-height: 20px;
    border-radius:5px;
    text-indent: 0px;
    margin-left: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/Search.vue